import axios from 'axios'
import {MessageBox} from 'element-ui'
import store from '@/store'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API, // api 的 base_url
  timeout: 10000, // request timeout
  responseType: 'blob',
  transformRequest: [
    function (data) {
      // 将数据转换为表单数据
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }
  ]
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['token'] = store.getters.token
    }
    return config
  },
  error => {
    console.log(error) // for debug
  }
)
// service.defaults.headers.common['Token'] = getToken()
// response interceptor
service.interceptors.response.use(
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    // 如果后台返回的是json，说明后台出错了，不能下载
    if (!response.headers['content-type'] || response.headers['content-type'].indexOf('application/json') !== -1) {
      console.log('//////////////////////')
      MessageBox.alert('系统异常，请稍后或者刷新后重试', '提示', {
        confirmButtonText: '确定',
        closeOnClickModal: false,
        type: 'info'
      })
      // location.reload()
      return Promise.reject('error')
    } else {
      return response
    }
  },
  error => {
    MessageBox.alert('下载失败，请刷新后重试！原因：' + error, '提示', {
      confirmButtonText: '确定',
      closeOnClickModal: false,
      type: 'info'
    })
    // location.reload()
    return Promise.reject(error)
  }
)

export default service
